module.exports = __webpack_public_path__ + "img/id_other.21386be.png";